import { useClearRefinements } from 'react-instantsearch';
import ClearFiltersButton from '../product-search/shared/ClearFiltersButton';

function CustomClearRefinements({ setRange, ...props }) {
  const { canRefine, refine } = useClearRefinements(props);

  return (
    <ClearFiltersButton
      canClear={canRefine}
      onClear={() => {
        setRange({ min: '', max: '' });
        refine();
      }}
    />
  );
}

export default CustomClearRefinements;
